<template>
  <div>
    <headNav></headNav>
    <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/xwdt.png" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
          <div style="width: 100%;" class="btn-group-vertical " role="group">
            <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
            <router-link to="/gsjj"><button type="button" class="btn btn-default btn-block">公司简介</button></router-link>
            <router-link to="/wdjf"><button type="button" class="btn btn-default btn-block">威盾技防</button></router-link>
            <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
            <router-link to="/xmzs"><button type="button" class="btn btn-default btn-block">项目展示</button></router-link>
            <router-link to="/wdtb"><button type="button" class="btn btn-default btn-block">威盾特保</button></router-link>
            <button type="button" class="btn btn-primary btn-block">新闻动态</button>
            <router-link to="/bzzl"><button type="button" class="btn btn-default btn-block">报纸专栏</button></router-link>
            <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
          </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 xq">
          <h3 style="font-weight: bold;margin-top: 0px;">{{result.title}}</h3>
          <p class="text-right">威盾官网 {{result.create_time}}</p>
          <div class="text-left" style="text-indent: 2em;margin-top: 10px;">
          <div id="content">

          </div>



          </div>
        </div>

        <!-- 显示大图部分 -->
        <div class="modal fade bs-example-modal-lg text-center" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" >
        	<div class="modal-dialog modal-lg" style="min-width: 90%" ><!-- style="display: inline-block; width: auto;" -->
        		<div class="modal-content">
        			<div class="modal-header">
        				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
        					<span aria-hidden="true">×</span>
        				</button>
        			</div>
        			<img alt="暂无图片" id="imgInModalID" class="img-responsive" src="" width="100%" >
        		</div>
        	</div>
        </div>
      </div>
    </div>
     <Base></Base>
  </div>

</template>

<script>


  export default {
    data() {
      return {
          result:{},
          content:'',

      }
    },
     created(){
    },
    mounted() {
      this.resourceId = this.$route.query.id
      console.log(this.resourceId)
      this.getNewsDetails(this.resourceId);
    },
    methods: {
      getNewsDetails(resourceId){
          this.$axios({
                      method: 'get',
                      url: this.HOST+'/wd/journalism/contentById?id='+resourceId,
                    }).then(res =>{
                      console.log(res)
                      this.result=res.data.data[0];
                      $("#content").append(res.data.data[0].content);
                      var imgs = $("#content img");
                      if(imgs.length>0){
                        for(var i=0; i<imgs.length;i++){
                          var img=imgs[i];
                          var str =this.HOST+"/wd/journalism/"+"system"+img.src.match(/system(\S*)/)[1];
                          img.src=str;
                          var path=imgs[i].src;
                          img.addEventListener('click',(function(path){
                              return function(){
                                  console.log(path);
                                  $("#imgInModalID").attr("src",path);
                                  $("#imgModal").modal('show');
                              }
                          })(path));
                        }
                      }



                    })

      },


    }




  }
</script>

<style>
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
.row{
    margin-left: 0px;
    margin-right: 0px;
  }
  .xq img{
    width: 100%;
    max-height: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/components/xwxq.vue